import React from 'react';
import { View } from 'react-native';
import LoadingScreen from '../../components/LoadingScreen/LoadingScreen';

/**
 * Loading screen component for the switching between chunks of
 * the hub.
 */
const Loading = () => (
  <View style={styles.container}>
    <LoadingScreen />
  </View>
);

export default Loading;

const styles = {
  container: {
    width: 1024,
    height: 576,
  },
};
